@let title = data().title;
@if (title) {
  <gc-text [variant]="'minorHeading'">
    {{ title | translate }}
    @if (data().titleCount !== undefined) {
      ({{ data().titleCount }})
    }
  </gc-text>
}
@let toolbar = data().tableToolbar;
@if (toolbar) {
  <app-table-toolbar
    [data]="toolbar"
    (itemsPerPageSelected)="setItemsPerPage($event)"
    (searchInputChanged)="onSearchInputChanged($event)"
  />
}
<div class="table-container">
  <ng-content></ng-content>
  @let pagination = data().pagination;
  @if (pagination) {
    <div class="divider"></div>
    <gc-pagination
      [numberOfPages]="pagination.numberOfPages"
      [activePage]="localActivePage()"
      (changed)="onPaginationChanged($event)"
    />
  }
</div>
